import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  EditOutlined,
  UserOutlined,
  UnorderedListOutlined,
  CheckSquareOutlined,
  HomeOutlined,
  CloudUploadOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, Spin } from "antd/lib";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import BpoRemarks from "./BpoRemarks";
import MyPolicyDetail from "./MyPolicyDetail";
import CompletedPolicy from "./CompletedPolicies";
import PospDashBoard from "../PospOnboard/Dashboard";
import ProfileTab from "../PospOnboard/ProfileTab";
import OnboardStep from "../PospOnboard/OnboardStep";
import MisPospForm from "./MisPosp";
import { TokenExpired } from "../../Redux/actions/NumBikeation";

const { Header, Sider, Content } = Layout;
export function PospMenu({ setDrawClick, open, setOpen, setuser }) {
  const dispatch = useDispatch();
  console.log("open", open);
  const ViewQuote = useSelector((state) => state?.posp?.PospViewQuote);
  console.log("ViewQuote", !ViewQuote);
  const [collapsed, setCollapsed] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");
  console.log("selectedContent", selectedContent);

  useEffect(() => {
    if (open === false) {
      setSelectedContent("");
      setDrawClick("");
      setCollapsed(false);
    }
  }, [open, selectedContent]);

  const handleMenuClick = (e) => {
    console.log("e?.key", e?.key);
    if (e?.key === "8") {
      setSpinning(true);
      setTimeout(() => {
        setSelectedContent("");
        setDrawClick("");
        dispatch((dispatch) => {
          dispatch({ type: "LOGOUT_POSP" });
          dispatch({ type: "RESET_STATE" });
        });
        dispatch(TokenExpired(true));
        setSpinning(false);
        setuser("");
        setOpen(false);
      }, 1000);
    } else {
      setSelectedContent(e?.key);
      setDrawClick(e?.key);
    }
  };
  const getDisplayContent = () => {
    switch (selectedContent) {
      case "1":
        return <ProfileTab setOpen={setOpen} />;
      case "2":
        return <OnboardStep setSelectedContent={setSelectedContent} />;
      case "3":
        return <PospDashBoard />;
      case "4":
        return <MyPolicyDetail />;
      case "5":
        return <CompletedPolicy />;
      case "6":
        return <MisPospForm />;
      case "7":
        return <BpoRemarks />;
      default:
        return "Content";
    }
  };
  return (
    // <div>
    <Spin spinning={spinning}>
      <Layout
      // style={{height: "-webkit-fill-available"}}
      >
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          className={selectedContent ? `menu-collap-bg` : `menu-layout-bg`}
        >
          {/* {console.log(collapsed)}
          <div className={collapsed ? `layout-logo-no` : `layout-logo`}>
            <Link to="/">
              <img src={Logo}></img>
            </Link>
          </div> */}
          <Menu
            className="menu-layout-ul"
            theme="dark"
            mode="inline"
            // defaultSelectedKeys={["1"]}
            onClick={handleMenuClick}
            selectedKeys={selectedContent}
            items={[
              {
                key: "1",
                icon: <UserOutlined />,
                label: "PROFILE",
              },
              {
                key: "2",
                icon: <EditOutlined />,
                label: "EDIT DETAILS",
              },
              {
                key: "3",
                icon: <HomeOutlined />,
                label: "DASHBOARD",
              },
              {
                key: "4",
                icon: <UnorderedListOutlined />,
                label: "LEADS",
              },
              {
                key: "5",
                icon: <CheckSquareOutlined />,
                label: "MY POLICY",
              },
              {
                key: "6",
                icon: <CloudUploadOutlined />,
                label: "MIS MOVEMENT",
              },
              {
                key: "7",
                icon: <QuestionCircleOutlined />,
                label: "REMARKS",
              },
              {
                key: "8",
                icon: <LogoutOutlined />,
                label: "LOGOUT",
              },
            ]}
          />
        </Sider>
        {selectedContent ? (
          <>
            <Layout className="site-layout">
              <Header
                //title="Menu"
                className="site-layout-background bg-head-layout"
                style={{
                  padding: 0,
                }}
              >
                <div className="bpo-header">
                  {React.createElement(
                    collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                    {
                      className: "trigger",
                      onClick: () => setCollapsed(!collapsed),
                    }
                  )}
                  <Button className="bpo-logout" onClick={() => setOpen(false)}>
                    Back
                  </Button>
                </div>
              </Header>
              <Content
                className="site-layout-background"
                style={{
                  margin: "10px 15px 0px 15px",
                  height: "100%",
                  minHeight: "650px",
                }}
              >
                <div style={{ background: "#fff" }}>{getDisplayContent()}</div>
              </Content>
            </Layout>
          </>
        ) : null}
      </Layout>
    </Spin>
  );
}
